import React from "react";
import "../../styles/terms.css";
import { NewFooter } from "../../components/newFooter";

export const Terms = () => {
  return (
    <>
      <div className="termsContainer">
        <div className="termsSectionMargin">
          <h2 className="text-al text-black header">Terms & Conditions</h2>
          <p className="text-dm termsPurpleWords">
            Last updated: January 18, 2023
          </p>
          <p className="text-dm text-black">
            Please read these Terms & Conditions (“Terms”, “Terms & Conditions”)
            carefully before using the{" "}
            <a href="https://elana.health">https://elana.health</a> website (the
            “Site”) (the “Service”) operated by Elana, Inc. (“Elana”, “us”,
            “we”, or “our”). Your access to and use of the Service is
            conditioned on your acceptance of and compliance with these Terms.
            These Terms apply to all visitors, users and others who access or
            use the Service.
          </p>
          <p className="text-dm text-black">
            By accessing or using the Service, you agree to be bound by these
            Terms. If you disagree with any part of the terms then you may not
            access the Service.
          </p>
          <p className="text-dm text-black">
            If you have a medical or other emergency, immediately call your
            doctor or dial 911 or your other local emergency assistance line.
            The Service is an interactive online service, which provides general
            information and content, as well as access to third party
            professionals who may offer independent services (“Professionals”).
            The Service does not, and is not intended to, replace your
            relationship with any practitioner or service, and the Service does
            not provide medical advice, care, diagnosis, or treatment. None of
            the content on the Service’s website or platform should be
            considered medical advice or an endorsement, representation or
            warranty that any particular medication or treatment is safe,
            appropriate, or effective for you. It is your responsibility to
            evaluate the accuracy, completeness, and usefulness of any
            information or content available through the Service, and you should
            seek advice from professionals (including your own physician or
            medical care provider) regarding any information, opinion, advice
            and other content you obtain through the Service. Under no
            circumstance will Elana be held responsible for any loss or damage
            caused by your reliance on information or other use of the Service,
            including but not limited to any products and/or services obtained
            through third parties, as further detailed in these Terms.
          </p>
        </div>
        <div className="termsSectionMargin">
          <h3 className="text-al text-black header">
            SERVICE DESCRIPTION and LICENSE TO USE
          </h3>
          <p className="text-dm text-black">
            The service provides individuals (“Members”) accessing it, general
            educational information on a variety of health and wellness related
            topics (“Content”), a directory for finding a potentially suitable
            women’s health specialist (“Providers”), and depending on Member’s
            subscription plan, the ability to track certain information. The
            service contains sections that are only available to registered
            Members of the Elana Service and sections only available for paid
            subscription plan members. Neither Elana nor any of its officers,
            directors, employees, or other agents provide medical care nor any
            other licensed profession through the Service, and does not
            interfere with the practice of medicine or any other licensed or
            not-licensed profession by Providers or other third parties, each of
            whom is responsible for his or her services and compliance with the
            requirements applicable to his or her profession and license.
          </p>
          <p className="text-dm text-black termsSectionMargin">
            We hereby grant you a limited, terminable, non-exclusive right to
            access and use the Site only for your personal use. This limited
            license authorizes you to view material on the Site and obtain
            Services solely for your personal, noncommercial use. Except as
            expressly stated in these Terms, we (and our third-party content
            providers, if any) reserve all rights to all materials and
            information on the Site, including, without limitation, written
            content, graphical and design elements (including the Site's "look
            and feel"), and service marks and trademarks. You may not sell,
            transfer, or assign any information, content, products, or services
            provided by us to any third party without our express written
            consent. You may not copy, modify, alter, or excerpt (or encourage
            or help others to copy, modify, alter, or excerpt) any content made
            available through the Site. You may not use (or encourage or help
            others to use) the Site for any purpose or in any manner that is
            prohibited by these Terms or by applicable law. You acknowledge and
            agree that these Terms in no way convey any right, title, or
            interest to you in any materials on the Site, including, without
            limitation, any statutory or common law copyright, patent or other
            intellectual property right in such materials.
          </p>
          <h4 className="text-al text-black header">
            Eligiblity and Registration
          </h4>
          <p className="text-dm text-black">
            You must be 18 years of age or over, or the legal age to form a
            binding contract in your jurisdiction if that age is greater than 18
            years of age, to create an account with us or use the Site and the
            Services. If you are between the ages of 13 and 18 or the applicable
            legal age in your jurisdiction, you can use the Site or Services
            only under the supervision of your parent or legal guardian who has
            agreed to these Terms & Conditions. Those under the age of 13 may
            not use the Site or Services.
          </p>
          <p className="text-dm text-black">
            If you do not qualify under these Terms & Conditions, do not use the
            Site or Services. Use of the Services is void where prohibited by
            applicable law, and the right to access the Site is revoked in such
            jurisdictions. By using the Site and/or the Services, you represent
            and warrant that you have the right, authority, and capacity to
            enter into these Terms & Conditions. The Site is administered in the
            U.S and users are responsible for compliance with any local, state,
            or federal laws applicable to their use of the Services or the Site.
          </p>
          <p className="text-dm text-black">
            To use the Site and obtain Services, you must create an account and
            become a Member. In order to create an account, you will need to
            provide your name, email, and date of birth. You must provide us
            with true and accurate registration information. We will not share
            your registration information with third parties, except as
            necessary to provide Services you request or otherwise with your
            permission. Upon account registration, we will assign you a username
            and password. You may not share your account information or
            credentials with anyone else, and you will be responsible for the
            actions of anyone who obtains your username and/or password and uses
            them to access the Site or obtain Services. You must notify us
            immediately of any unauthorized use of your username and password.
          </p>
        </div>
        <div className="termsSectionMargin">
          <h3 className="text-al text-black header">PRIVACY</h3>
          <p className="text-dm text-black">
            By using the Service, you consent to our processing of your
            information consistent with our Privacy Policy. Please review the
            Privacy Policy for a description of how we may collect and use your
            personal information. The Privacy Policy is hereby incorporated into
            these Terms of Use by reference and constitutes a part of these
            Terms of Use.
          </p>
          <p className="text-dm text-black termsSectionMargin">
            Furthermore, by using the Service, you authorize the release of your
            information, including but not limited to potentially confidential
            protected health information, as described in these Terms and our
            Privacy Policy. You acknowledge, understand, and agree that this
            authorization is voluntary, that the information to be disclosed may
            be protected by law, and the use/disclosure is to be made to conform
            to your direction per your use of the Service. The information that
            is used and/or disclosed pursuant to this authorization may be
            redisclosed by the recipient unless the recipient is covered by
            state laws that limit the use and/or disclosure of your confidential
            protected health information, if any.
          </p>
          <h4 className="text-al text-black">Intellectual Property</h4>
          <p className="text-dm text-black">
            The Service and its original content, features and functionality are
            and will remain the exclusive property of Elana and its licensors.
          </p>
          <p className="text-dm text-black termsSectionMargin">
            We respect the rights of all copyright holders. If you believe your
            work has been copied in a way that constitutes copyright
            infringement, contact us at hello@elana.health, and provide the
            following information as required by the Online Copyright
            Infringement Liability Limitation Act of the Digital Millennium
            Copyright Act, 17 U.S.C. §512: (i) signature of a person authorized
            to act on behalf of the owner of the allegedly infringing work; (ii)
            identification of the work claimed to have been infringed and
            information reasonably sufficient to permit us to locate the
            material on our Service; (iii) contact information of the
            complaining party; (iv) a statement that the complaining party has a
            good-faith belief that use of the material is not authorized by the
            copyright owner; and (v) a statement that the information in the
            notification is accurate, and under penalty of perjury, that the
            complaining party is authorized to act on behalf of the owner of the
            allegedly infringed work.
          </p>
          <h4 className="text-al text-black">Links To Other Websites</h4>
          <p className="text-dm text-black">
            Our Service may contain links to third-party web sites or services,
            which may offer various other products and/or services, and that are
            not owned or controlled by Elana.
          </p>
          <p className="text-dm text-black">
            Elana has no control over, and assumes no responsibility for, the
            content, privacy policies, or practices of any third-party web sites
            or services. Elana cannot ensure users will be satisfied with any
            products and/or services obtained through such third parties, and
            does not endorse any such products, services, of third-party
            providers. Elana does not prescreen content or products found on
            such third-party websites, and you are encouraged to evaluate, and
            bear all risks associated with, the use and usefulness of, and
            reliance upon content found on and services provided through such
            third-party sites.
          </p>
          <p className="text-dm text-black">
            You acknowledge and agree that Elana does not make any
            representations or warranties related to your use of any third party
            materials services nor related to any products or services obtained
            through third parties. You further acknowledge and agree Elana shall
            not be responsible or liable, directly, or indirectly, for any
            damage or loss caused or alleged to be caused by or in connection
            with use of or reliance on any such content, goods or services
            available on or through any such web sites or services. Any dealings
            you have with such third parties are between you and the third
            party, and you acknowledge and agree that Elana is not liable for
            any loss or claim you may, at any time, have against any such third
            party nor shall Elana be required to become involved in any dispute
            between you and any third party.
          </p>
          <p className="text-dm text-black termsSectionMargin">
            We strongly advise you to read the terms and conditions and privacy
            policies of third-party web sites or services that you visit.
          </p>
          <h4 className="text-al text-black">
            Termination and Rules of Conduct
          </h4>
          <p className="text-dm text-black">
            Elana and its officers, directors, and other agents are the sole
            interpreter of the Elana platform and the rules of conduct detailed
            herein. Elana may, in its sole discretion, terminate or suspend a
            Member’s access immediately, without prior notice or liability, for
            breaching any of the Terms or violating any of the rules of conduct
            detailed herein, and for any reason whatsoever.
          </p>
          <p className="text-dm text-black">Security Rules:</p>
          <p className="text-dm text-black">
            Members are prohibited from violating or attempting to violate the
            security of the Elana platform, including but not limited to: (i)
            accessing data not intended for such Member or logging into a server
            or account which the Member is not authorized to access; (ii)
            attempting to probe, scan or test the vulnerability of a system or
            network or to breach security or authentication measures without
            written authorization from Elana; and (iii) attempting to interfere
            with service provided to any other Member. In addition to other
            penalties, violation of this section may result in civil or criminal
            liability, and Elana may investigate occurrences, and cooperate with
            law enforcement authorities in prosecuting anyone involved in such
            violations.
          </p>
          <p className="text-dm text-black">
            All provisions of the Terms which by their nature should survive
            termination shall survive termination, including, without
            limitation, ownership provisions, warranty disclaimers, indemnity,
            and limitations of liability.
          </p>
        </div>
        <div className="termsSectionMargin">
          <h3 className="text-al text-black header">USER GENERATED CONTENT</h3>
          <p className="text-dm text-black">
            The Service may contain profiles, information exchange platforms,
            and other interactive features. Elana may, from time to time and in
            its sole discretion, request or permit you to submit, upload, and
            otherwise publish text, audio, and/or visual content, including
            commentary and feedback to other users ("User Generated Content").
            In addition, Elana may, from time to time and in its sole
            discretion, permit you to view the User Generated Content of other
            users, including other Members and Practitioners. Except as
            otherwise detailed herein, you own the User Generated Content that
            you submit or post through the Service, and grant Elana a
            non-exclusive, perpetual, irrevocable, worldwide, transferable and
            sub-licensable license and right to use, copy, modify, distribute,
            publish, and process information and User Generated Content you
            provide, without any further consent, notice and/or compensation to
            you or others, provided, however, that such use shall comply with
            applicable laws.
          </p>
          <p className="text-dm text-black">
            You agree, represent, and warrant that your User Generated Content:
            (i) does not violate any law; (ii) does not violate or infringe upon
            the copyrights, patents, trademarks, service marks, trade secrets,
            or other intellectual property and proprietary rights of any person
            or entity; (iii) is not defamatory, abusive, harassing, threatening,
            impersonating, or intimidating to any other person or entity; (iv)
            is not libelous, threatening, obscene, pornographic, hateful, or
            could give rise to any civil or criminal liability under U.S. or
            international law; (v) does not include any bugs, viruses, worms,
            trap doors, Trojan horses, or other harmful code or properties; and
            (vi) does not include URLs or links to websites or other platforms
            that compete with Elana and its Services.{" "}
          </p>
          <p className="text-dm text-black">
            Elana reserves the right to: (i) remove or refuse to post User
            Generated Content for any or no reason in our sole discretion; (ii)
            take any action with respect to User Generated Content that we deem
            necessary or appropriate in our sole discretion, including if we
            believe that such User Generated Content violates this Agreement,
            infringes any intellectual property right or other right of any
            person or entity, or which could otherwise create liability for
            Elana; and (iii) disclose information about you to any third party
            who claims that material posted by you violates their rights.
          </p>
          <p className="text-dm text-black">
            You agree that Elana may use your name, trademark, service mark,
            logo, trade dress and other identifiers for marketing and
            promotional purposes without additional compensation.
          </p>
          <p className="text-dm text-black">
            You understand and acknowledge that you are responsible for User
            Generated Content submitted by you and others using your account
            credentials, and you acknowledge and agree that you have full
            responsibility for such content, including its legality,
            reliability, accuracy, and appropriateness. Submissions and opinions
            that are User Generated Content are those of the individuals or
            entities expressing such submissions or opinions, and do not reflect
            Elana’s opinions. Elana is not responsible or liable to any third
            party for User Generated Content.
          </p>
          <p className="text-dm text-black">
            If you believe that any content on the website infringes copyrights
            you own, please provide Elana written notice in accordance with the
            Notice and Communications provision below.
          </p>
        </div>
        <div className="termsSectionMargin">
          <h3 className="text-al text-black header termsSectionMargin">TYPES OF USERS</h3>
          <h4 className="text-al text-black header">Members</h4>
          <p className="text-dm text-black">
            We created Elana to increase Members’ knowledge of and experience
            with healthcare, starting with pelvic health issues, and we strive
            to create an exceptional user experience. While we work hard to make
            that happen, you acknowledge that we have no control over, and no
            duty to take any action regarding: (a) which members gain access to
            the Site and/or the Services, (b) what Content you access, (c) what
            affects the Content may have on you, (d) how you may interpret or
            use the Content, or (e) what actions you may take as a result of
            having been exposed to the Content. While we seek to match our
            members with providers that match the care style they are looking
            for (including, but not limited to, preferences such as:
            communication style, budget restrictions, tendency toward
            “traditional” care vs. “non-traditional” methods, treatment methods,
            provider credentials) we do not provide medical or healthcare
            services and are not liable for the healthcare decisions that you
            make. In addition, we do not endorse, and nothing on the Elana
            platform shall be deemed an endorsement of any third party,
            including any Providers (as defined below) or their related goods
            and/or services. Any suggested matches obtained through the Elana
            platform are intended for information purposes only and are not
            medical recommendations.
          </p>
          <p className="text-dm text-black">
            You release us from all liability for you having acquired, you
            having not acquired, or your use of Content. We make no
            representations or warranties regarding suggestions or
            recommendations of services or products offered or purchased through
            the Site and/or the Services. We have no special relationship with
            or fiduciary duty to you.
          </p>
          <p className="text-dm text-black termsSectionMargin">
            You warrant that you are not located in, or ordinarily reside in, a
            country that is subject to U.S. laws and regulations preventing
            Elana from providing you access to the website or Services. Your
            location is determined by your physical location, and use of a
            virtual private network service, IP routing services, or other
            similar service for the purpose of circumventing these laws is
            prohibited. Furthermore, you warrant that you are not named on any
            government prohibited, denied, unverified-party, sanctions,
            debarment, or exclusion list or export-controlled related restricted
            party list (collectively, “Sanctions Lists”); and you agree you must
            and will immediately discontinue use of the Services if you are
            placed on any Sanctions List at any time. You also warrant you will
            not export, re-export, or transfer Services to an entity on any
            Sanctions List.
          </p>
          <h4 className="text-al text-black header">
            Providers and Professionals
          </h4>
          <p className="text-dm text-black">
            In addition to providing Services to our Members, licensed and/or
            unlicensed health care providers or other professionals may also use
            and access the Elana Site (“Providers”). Such use includes but is
            not limited to being listed as a practitioner or other provider on
            the Elana directory or featured as a third party professional and
            providing access to such third party’s independent website and
            services.
          </p>
          <p className="text-dm text-black">
            To be approved as a Provider or Professional on the Site, Providers
            must acknowledge and accept the following Provider Pledge. Providers
            and Professionals acknowledge and agree that they: (a) are
            responsible for the specific regulations that apply to them based on
            their type of business, credentials, and practice location,
            including but not limited to, in the case of providing telehealth,
            the ability to practice with members across applicable geographical
            boundaries (e.g., including but not limited to state, province, and
            country lines); (b) must maintain proper licenses, as required by
            their jurisdiction, and provide proof upon request, (c) must obtain
            and at all times while using the Site and Service, maintain active
            and sufficient liability coverage for their own business or
            practice, and provide proof of such insurance if and when requested.
          </p>
          <p className="text-dm text-black">
            Elana reserves the right to terminate use of the Service if it is
            found that a Provider or Professionals is not practicing according
            to the Provider Pledge or fails to comply with the requirements
            detailed above.
          </p>
          <p className="text-dm text-black">
            The Providers and Professionals utilizing or featured on the Service
            are subscribers to or licensees of the Service and not employees,
            representatives, or agents of Elana in any way. Any opinions,
            advice, or information expressed by a Provider or Professional are
            that of Provider or Professional alone. Any opinions, advice, or
            recommendations do not reflect the opinions of Elana. Elana does not
            recommend or endorse any specific tests, providers, products,
            procedures, medications, devices, opinions, or other information
            that may be mentioned on any medium of the Service by a Provider or
            Professional.
          </p>
          <p className="text-dm text-black">
            The inclusion of Providers or Professionals on the Service or in any
            directory located on the Service does not imply recommendation or
            endorsement of such Provider or Professional nor is such information
            intended as a tool for verifying the credentials, qualifications, or
            abilities of any Provider or Professional. Such information is
            provided on an “as-is” basis and Elana disclaims all warranties
            either express or implied as further detailed in these Terms. We
            encourage you to use your independent and sound judgment and confer
            with your own healthcare professional before obtaining the services
            of Providers or Professionals.
          </p>
        </div>
        <div className="termsSectionMargin">
          <h3 className="text-al text-black header">PURCHASES</h3>
          <p className="text-dm text-black">
            To the extent the Service or any portion thereof is made available
            for any fee, you may be required to select a payment plan and
            provide Elana with payment information. You represent and warrant
            that such information is true and that you are authorized to use
            such payment information. Furthermore, you agree to promptly update
            your account information in the event of any changes. You agree to
            pay the amount that is specified in the payment plan, if any, and
            hereby authorize Elana to process payments either directly or using
            a payment processor. You agree to be responsible for all associated
            taxes.
          </p>
          <p className="text-dm text-black">
            We may make certain products, features, and services available for
            access or purchase (“Purchases”) on or through the Elana site. You
            agree to pay any applicable fees for Purchases you make, including
            but not limited to, applicable sales, use, and other taxes or fees.
            Certain products, services or features that you purchase or access
            via the Elana site, such as Purchases from Third-Party Providers,
            may be subject to additional terms and conditions presented to you
            at the time of such purchase or access. We may receive a commission
            or other compensation on some purchases made on, through, or linked
            from the Elana site.
          </p>
          <p className="text-dm text-black">
            Images available of third-party Products (“Third-Party Products”)
            may not capture the actual appearance, look and feel,
            specifications, or functionality of such Third-Party Products.
            Except for Products that specifically identify Elana as the seller,
            all transactions for Third-Party Products available on or through
            the Service shall be solely between you and the third-party
            Provider. If you purchase, order, or obtain Third-Party Products on
            or through the Service, Elana assumes no responsibility for the
            quality, quantity, size, character, fitness for a particular
            purpose, specifications, features, functionality, safety, or
            legality of such products, the truth or accuracy of the listings, or
            the ability of the third-party Provider to sell, ship, or otherwise
            provide such products. You agree that Elana is not responsible, and
            shall have no liability, with respect to any Third-Party Products
            available on or through the Service. In the event of any failure of
            a Third-Party Product to conform to any applicable warranty, you
            should contact the applicable Third-Party Provider for assistance.
          </p>
        </div>
        <div>
          <h3 className="text-al text-black header">
            DISCLAIMER, INDEMNIFICATION, AND LIMITATION OF LIABILITY
          </h3>
          <p className="text-dm text-black">
            WE PROVIDE THE SERVICES “AS IS” AND “AS AVAILABLE.” WE MAKE NO
            EXPRESS OR IMPLIED WARRANTIES OR GUARANTEES ABOUT THE SERVICES. TO
            THE MAXIMUM EXTENT PERMITTED BY LAW, WE HEREBY DISCLAIM ALL
            WARRANTIES, EXPRESS OR IMPLIED, INCLUDING ALL STATUTORY WARRANTIES,
            WITH RESPECT TO THE SERVICES AND THE SITE, INCLUDING, WITHOUT
            LIMITATION, ANY WARRANTIES THAT THE SERVICES ARE MERCHANTABLE, OF
            SATISFACTORY QUALITY, ACCURATE, FIT FOR A PARTICULAR PURPOSE OR
            NEED, OR NON-INFRINGING. WE DO NOT GUARANTEE THAT THE RESULTS THAT
            MAY BE OBTAINED FROM THE USE OF THE SERVICES WILL BE EFFECTIVE,
            RELIABLE OR ACCURATE OR WILL MEET YOUR REQUIREMENTS. WE DO NOT
            GUARANTEE THAT YOU WILL BE ABLE TO ACCESS OR USE THE SERVICES
            (EITHER DIRECTLY OR THROUGH THIRD-PARTY NETWORKS) AT TIMES OR
            LOCATIONS OF YOUR CHOOSING. WE ARE NOT RESPONSIBLE FOR THE ACCURACY,
            RELIABILITY, TIMELINESS OR COMPLETENESS OF INFORMATION PROVIDED BY
            MEMBERS OR PROVIDERS OF THE SERVICES OR ANY OTHER DATA OR
            INFORMATION PROVIDED OR RECEIVED THROUGH THE SERVICES. EXCEPT AS
            EXPRESSLY SET FORTH HEREIN, ELANA MAKES NO WARRANTIES ABOUT THE
            INFORMATION SYSTEMS, SOFTWARE, AND FUNCTIONS MADE ACCESSIBLE THROUGH
            THE SERVICES OR ANY OTHER SECURITY ASSOCIATED WITH THE TRANSMISSION
            OF SENSITIVE INFORMATION. ELANA DOES NOT WARRANT THAT THE SITE OR
            THE SERVICES WILL OPERATE ERROR-FREE, BUG-FREE OR FREE FROM DEFECTS,
            THAT LOSS OF DATA WILL NOT OCCUR, OR THAT THE SERVICES, SOFTWARE OR
            SITE ARE FREE OF COMPUTER VIRUSES, CONTAMINANTS OR OTHER HARMFUL
            ITEMS.
          </p>
          <p className="text-dm text-black">
            Your use of the Site, the internet in general, any materials you
            access via our Site and your conduct online or offline (including
            any interactions with third party service providers) are at your own
            risk.
          </p>
          <p className="text-dm text-black">
            You shall indemnify and defend Elana, and our officers, employees,
            and other agents against any costs, expenses (including reasonable
            attorneys' fees whether arising out of a third-party claim or in
            enforcing this indemnification), claims, judgments, settlements and
            damages (including all damages awarded to third parties payable by
            us, but in all cases only our direct damages) arising out of, or
            related to, your use of the Site, Services provided by you to
            Members or other users, or otherwise caused by your violation of any
            of these Terms.
          </p>
          <p className="text-dm text-black">
            NEITHER ELANA, NOR ANY OF OUR OFFICERS, DIRECTORS, EMPLOYEES OR
            AGENTS, WILL BE LIABLE TO YOU OR ANY OTHER PERSON FOR ANY INDIRECT,
            CONSEQUENTIAL, PUNITIVE OR SPECIAL DAMAGES ("NON-DIRECT DAMAGES"),
            OF ANY KIND, WHETHER BY CONTRACT, TORT OR OTHERWISE, ARISING OUT OF
            OR IN CONNECTION WITH THESE TERMS OR YOUR USE OF THE SITE AND
            SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH
            DAMAGES.
          </p>
          <p className="text-dm text-black">
            OUR LIABILITY, INCLUDING OUR OFFICERS, DIRECTORS, EMPLOYEES OR
            AGENTS TO YOU OR ANY OTHER PERSON FOR DIRECT DAMAGES SHALL BE
            LIMITED TO THE GREATER OF US $100 OR THE FEES PAID BY YOU FOR OUR
            SERVICES DURING THE 6 MONTHS PRECEDING THE EVENTS THAT GAVE RISE TO
            YOUR FIRST CLAIM AGAINST US FOR DAMAGES. IN JURISDICTIONS THAT DO
            NOT ALLOW EXCLUSION OR LIMITATION OF LIABILITY FOR NON-DIRECT
            DAMAGES, THESE LIMITATIONS SHALL APPLY TO BOTH DIRECT AND NON-DIRECT
            DAMAGES.
          </p>
          <p className="text-dm text-black">Governing Law</p>
          <p className="text-dm text-black">
            These Terms shall be governed and construed in accordance with the
            laws of the State of Florida, United States without regard to its
            conflict of law provisions. Each party irrevocably consents and
            agrees that any legal action, suit or proceeding against either of
            them arising out of, relating to or in connection with the
            transaction contemplated hereby or disputes relating hereto may be
            brought only in the courts of the State of Florida, and hereby
            irrevocably accepts and submits to the exclusive jurisdiction of the
            aforesaid courts, with respect to any such action, suit or
            proceeding. EACH PARTY WAIVES ANY RIGHT TO TRIAL BY JURY IN ANY
            ACTION, SUIT OR PROCEEDING BROUGHT TO ENFORCE, DEFEND OR INTERPRET
            ANY RIGHTS OR REMEDIES ARISING UNDER, RELATING TO OR IN CONNECTION
            WITH THESE TERMS.
          </p>
          <p className="text-dm text-black">
            FURTHERMORE, YOU AGREE THAT IN THE EVENT OF ANY DISPUTE OR CLAIM
            AGAINST ELANA YOU MAY BRING SHALL BE DONE IN YOUR CAPACITY AS AN
            INDIVIDUAL ONLY, AND NOT AS A PLAINTIFF, PARTY, OR CLASS MEMBER OF
            ANY PURPORTED CLASS ACTION.
          </p>
          <p className="text-dm text-black termsSectionMargin">
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights. If any provision of
            these Terms is held to be invalid or unenforceable by a court, the
            remaining provisions of these Terms will remain in effect. These
            Terms constitute the entire agreement between us regarding our
            Service and supersede and replace any prior agreements we might have
            between us regarding the Service.
          </p>
          <h4 className="text-al text-black header">Changes</h4>
          <p className="text-dm text-black">
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. If a revision is material, we will try to
            provide at least 15 days’ notice prior to any new terms taking
            effect. What constitutes a material change will be determined at our
            sole discretion.
          </p>
          <p className="text-dm text-black termsSectionMargin">
            By continuing to access or use our Service after those revisions
            become effective, you agree to be bound by the revised terms. If you
            do not agree to the new terms, please stop using the Service.
          </p>
          <h4 className="text-al text-black header">Headings</h4>
          <p className="text-dm text-black termsSectionMargin">
            The headings of the sections of this Agreement are for convenience
            only, do not form a part hereof, and in no way limit, define,
            describe, modify, interpret, or construe the meaning, scope or
            intent of this Agreement or any terms or conditions therein.
          </p>
          <h4 className="text-al text-black header">Electronic Contracting</h4>
          <p className="text-dm text-black termsSectionMargin">
            Your affirmative act of using the Services and/or creating an
            account constitutes your electronic signature and consent to enter
            into this Agreement, which includes our Privacy Policy, and other
            additional terms.
          </p>
          <h4 className="text-al text-black header">Contact Us and Notice</h4>
          <p className="text-dm text-black">
            If you have any questions about these Terms, please contact us. Any
            legal notices, including any notice of a claimed dispute, shall be
            sent notices to us by mail to: Shraybman Law, PLLC Attn: Jessica
            Shraybman 475 Brickell Ave., #4113 Miami, FL 33131 or by email at{" "}
            <a href="mailto:hello@elana.health?subject=LEGAL">hello@elana.health</a> to the attention of LEGAL. Notices to you will be
            sent by mail or by email to the addresses you provide when
            registering. Notices shall be deemed given on the day actually
            received by the recipient.
          </p>
        </div>
        <p className="text-center text-dm fs-16-12 text-black py-4">
          Disclaimer: The information provided through Elana Health website and
          services is not intended or implied to be a substitute for
		  <br className="mobile-view-hidden" />
          professional medical advice, diagnosis or treatment.
        </p>
      </div>
      <NewFooter />
    </>
  );
};
